import { Text, View } from '@react-pdf/renderer';
import React from 'react';
import { styles } from '../../../utils/styles';
import defaults from '../../../translations/en.json';
import { AREA_CODE, NUMBER, TYPE } from '../constants';
export const Phones = ({
  phones
}) => {
  const phoneList = Array.isArray(phones);
  return phoneList ? /*#__PURE__*/React.createElement(React.Fragment, null, phones.map(phone => /*#__PURE__*/React.createElement(Phone, {
    phone: phone,
    key: phone[NUMBER]
  }))) : /*#__PURE__*/React.createElement(Phone, {
    phone: phones
  });
};
export const Phone = ({
  phone
}) => /*#__PURE__*/React.createElement(Text, {
  style: styles.FacesheetHeaderField
}, `${phone[TYPE]}: (${phone[AREA_CODE]})-${phone[NUMBER]}\n`);
export const Allergies = ({
  allergies
}) => /*#__PURE__*/React.createElement(View, {
  style: [styles.width100, styles.borderBottomBlack]
}, /*#__PURE__*/React.createElement(Text, {
  style: styles.printerHeaderText
}, `${defaults.allergies}:`), /*#__PURE__*/React.createElement(Text, {
  style: [styles.FacesheetText, styles.pYPointOneCm]
}, allergies));
export const AgencyHeader = ({
  patient
}) => /*#__PURE__*/React.createElement(View, {
  style: [styles.width100, styles.textAlignCenter]
}, /*#__PURE__*/React.createElement(Text, {
  style: styles.printerHeaderText
}, patient.hospiceName), /*#__PURE__*/React.createElement(Text, {
  style: styles.printerSubHeader
}, `${defaults.site}:`, " ", patient.siteName));